// Loader for our JS Components

import type Glide from '@glidejs/glide';

import { type App } from '~/app';

export default class JsController {
    title = 'Unnamed';
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];
    carousels: Glide[] = [];
    mountFunctions: Array<() => void> = [];
    unmountFunctions: Array<() => void> = [];

    constructor(readonly app: App, title: string) {
        this.title = title;
    }

    init() {
        // Run Mount on app ready
        this.app.logger.debug(`[Stockland FE] Initialise Stockland ${this.title} Component`);
        this.app.afterMount
            .then(() => {
                for (const mountFunction of this.mountFunctions) {
                    mountFunction();
                }
            })
            .catch((error) => {
                // console.trace();
                throw new Error(`[Stockland FE] Unable to register Stockland ${this.title} component`, error);
            });
        return this.unmount;
    }

    addMountFunction(function_: () => void) {
        this.mountFunctions.push(function_)
    }

    addUnmountFunction(function_: () => void) {
        this.unmountFunctions.push(function_)
    }

    addCarouselInstance(carousel: Glide) {
        this.carousels.push(carousel);
    }

    addListener(element: Element | Window | Document, event: string, listener: EventListenerOrEventListenerObject) {
        
        element.addEventListener(event, listener);
        this.listeners.push([element, event, listener]);
    }

    unmount() {
        // Remove all listeners
        for (const [element, event, listener] of this.listeners) {
            element.removeEventListener(event, listener);
        }
        
        // Unmount carousels
        for (const carousel of this.carousels) {
            carousel.destroy();
        }

        // Run all unmount functions
        for (const function_ of this.unmountFunctions) function_();

        this.app.logger.debug(`[DXA] ${ this.title } component destroyed`);
    }
}